import React from 'react';
import PropTypes from 'prop-types';

import {Box, Typography, Paper} from 'views/components';
import {AssignmentOutlined as AssignmentIcon} from 'views/icons';
import {MarkdownViewer, Translate, translate} from 'views/module';

const CareRoutine = (props) => {
  const {careRoutine} = props;

  const clientPreferences = careRoutine?.clientPreferences?.blob || '';
  const dailyTasks = careRoutine?.dailyTasks?.blob || '';

  return (
    <Paper
      sx={{
        borderRadius: 3,
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          px: 2,
          py: 1,
          backgroundColor: 'grey.100',
          justifyContent: 'space-between',
          borderRadius: '4px 4px 0 0',
          width: '100%',
        }}
      >
        <Box sx={{display: 'flex', alignItems: 'center'}}>
          <AssignmentIcon sx={{mr: 1}} />
          <Typography variant="h6">
            <Translate expression="loomLead.LoomLeadDetail.Careplan.CareRoutine.Title" />
          </Typography>
        </Box>
      </Box>
      <Box sx={{p: 2}}>
        <Typography variant="subtitle1" sx={{mb: 1, fontWeight: 'bold'}}>
          <Translate expression="loomLead.LoomLeadDetail.Careplan.CareRoutine.ClientPreferences" />
        </Typography>
        <MarkdownViewer
          value={clientPreferences || translate('loomLead.LoomLeadDetail.Careplan.CareRoutine.NoPreferences')}
          truncate={true}
        />
        <Typography variant="subtitle1" sx={{mt: 2, mb: 1, fontWeight: 'bold'}}>
          <Translate expression="loomLead.LoomLeadDetail.Careplan.CareRoutine.Tasks" />
        </Typography>
        <MarkdownViewer
          value={dailyTasks || translate('loomLead.LoomLeadDetail.Careplan.CareRoutine.NoTasks')}
          truncate={true}
        />
      </Box>
    </Paper>
  );
};

CareRoutine.propTypes = {
  careRoutine: PropTypes.shape({
    clientPreferences: PropTypes.shape({
      blob: PropTypes.string,
      editorType: PropTypes.string,
    }),
    dailyTasks: PropTypes.shape({
      blob: PropTypes.string,
      editorType: PropTypes.string,
    }),
  }).isRequired,
};

export default CareRoutine;
